<template>
<div class="report-detail">
    <el-row class="tool-bar">
        <el-button v-if="depPermission" class="base-btn add-btn" @click="showDialog" style="width:120px">
            加入主題
            <img src="../../assets/icon/ic_add.png" alt="A" class="add-icon">
        </el-button>
        <el-button v-show="sels.length > 0" class="fn-btn delete-btn" @click="deleteCourses">刪除
            <img src="../../assets/icon/ic_delete_white.png" alt="D" class="delete-icon">
        </el-button>
    </el-row>
    <el-row class="page-bar">
        <div class="total-results"> {{totalResult}} </div>
        <el-pagination layout="prev, pager, next" prev-text="prev" next-text="next" 
            :current-page="this.$store.state.course.listStatus.currentPage" 
            @current-change="course_current_change" 
            :page-size="this.$store.state.course.listStatus.pageSize" 
            :total="this.$store.state.course.listStatus.total" style="float:right;">
        </el-pagination>
    </el-row>
    <!--列表-->
    <el-table   :data="courses" 
                v-loading="listLoading" 
                empty-text="暫無數據"
                @selection-change="selsChange" 
                @sort-change="sortChange"
                @row-click="rowClick" 
                style="min-width: 100%;">
			<el-table-column min-width="3%" v-if="depPermission" type="selection" >
			</el-table-column>
			<el-table-column min-width="14%" v-if="depPermission" prop="code" label="編號" sortable="custom">
			</el-table-column>
			<el-table-column min-width="33%" prop="title" label="主題" class="title-column" sortable="custom"> 
			</el-table-column>
			<el-table-column min-width="23%" prop="department" label="部門" sortable="custom">
			</el-table-column>
			<el-table-column min-width="13%" prop="category" label="分類" sortable="custom">
			</el-table-column>
			<el-table-column min-width="13%" prop="level" label="程度" :formatter="formatLevel" sortable="custom">
			</el-table-column>
			<el-table-column min-width="13%" prop="type" label="類型" :formatter="formatType">
			</el-table-column>
			<el-table-column min-width="19%" prop="rating" label="評分" sortable="custom">
				<template slot-scope="scope">	
					<StarRating v-if="courses[scope.$index].rating > 0" :rating="courses[scope.$index].rating" text-class="star-rating" :max-rating="5" :star-size="16" :read-only="true" :increment="0.1"></StarRating>
					<StarRating v-else :rating="courses[scope.$index].rating" :show-rating="false" text-class="star-rating" :max-rating="5" :star-size="16" :read-only="true" :increment="0.1"></StarRating>
				</template>
			</el-table-column>
			<el-table-column min-width="16%" prop="mtime" label="更新時間" :formatter="formatMtime" sortable="custom">
			</el-table-column>
		</el-table>
        <el-dialog  title="加入主題" :show-close="false" :visible.sync="dialogFormVisible" customClass="dialogWidth">
            <el-form :model="form" ref="form" label-position="top">
                <el-form-item :label="dialogTitle" prop="id">
                    <el-autocomplete
                        style="width:90%"
                        popper-class="course-autocomplete"
                        custom-item="autocomplete-item"
                        v-model="form.resourceTitle"
                        :fetch-suggestions="querySearchAsync"
                        placeholder="主題名稱/編號"
                        @select="handleSelect"
                    >
                    </el-autocomplete>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogFormVisible = false">取消</el-button>
                <el-button type="primary" @click="addCourse">加入{{ typeString }} </el-button>
            </div>
        </el-dialog>
        <hint v-show="hint.display && this.$store.state.hintStatus.table" :message="hint.message" @close="closeHint"></hint>
</div>
</template>

<script>
import util from '@/common/js/util';
import API from '../../api/api';
import Vue from 'vue';
Vue.component('autocomplete-item', {
    functional: true,
    render: function (h, ctx) {
        var item = ctx.props.item;
        return h('li', ctx.data, [
            h('div', { attrs: { class: 'title' } }, [item.title]),
            h('span', { attrs: { class: 'code' } }, [item.code])
        ]);
    },
    props: {
        item: { type: Object, required: true }
    }
});
export default {
    name: 'CourseType',
    props: {
        courseType: {
            type: Number
        },
        selectedDepId: {
            type: Array
        }
    },
    data() {
        return {
            dialogFormVisible: false,
            form: {
                resourceTitle: null,
            },
            selectedItem: null,
            courses: [],
            totalResult:'',
            listLoading: false,
            sels: [],
            hint: {
                message: '',
                display: false,
            },
        }
    },
    computed: {
        depPermission() {
            if (this.$store.state.isBackendMode && !this.$store.state.isSystemAdminMode &&
                (this.selectedDepId[1] === this.$store.state.userActualDepId)) {
                return true
            } 
            return false
        },
        typeString() {
          if (this.courseType === 0) {
            return "選修"
          } else if (this.courseType === 1) {
            return "必修"
          }
          return "";
        },
        dialogTitle() {
            if (this.courseType === 0) {
            return "加入主題為選修課"
          } else if (this.courseType === 1) {
            return "加入主題為必修課"
          }
          return "";
        },
    },
    watch: {
        'selectedDepId': {
            immediate: false,
            handler(val) {
                this.reloadCourse();
            }
        },
        '$store.state.course.keyword' : {
            immediate: false,
            handler(val) {
                this.reloadCourse();
            }
        }
    },
    methods: {
        init() {
            this.getCourse();
        },
        reloadCourse() {
            this.$store.state.course.listStatus.currentPage = 1;
            this.$store.state.course.listStatus.offset = 0;
            this.sels.splice(0);
            this.getCourse();
        },
        getCourse() {
            this.listLoading = true;
            this.courses.splice(0);
            
            API.getCourse({
					course_actual_depid: this.selectedDepId[1],
					course_type: this.courseType,
					offset: this.$store.state.course.listStatus.offset,
					keyword: this.$store.state.course.keyword,
                    by: this.$store.state.course.listStatus.by,
					order: this.$store.state.course.listStatus.order,
				}).then((response) => {
                if(!response) {
                    this.listLoading = false;
                    this.showHint('取得資源錯誤!');
                } else {
                    if(response.status) {
                        redirectLogin(response.data);
                        this.listLoading = false;
                        if(!JSON.parse(response.request.response).error_msg) {
                            this.showHint('取得資源錯誤!');
                        } else {
                            this.showHint(JSON.parse(response.requt.response).error_msg);	
                        }
                    } else {
                        this.listLoading = false;
                        //全部筆數
                        this.$store.state.course.listStatus.total = response.total;
                        //目前頁數
                        this.$store.state.course.listStatus.currentPage = 
                        (this.$store.state.course.listStatus.offset / this.$store.state.course.listStatus.pageSize) + 1;
                        //資源列表顯示結果字串
                        if(this.$store.state.course.listStatus.total === 0) {
                            this.totalResult = ' 共 ' + this.$store.state.course.listStatus.total + ' 筆結果';
                        } else {
                            this.totalResult = this.$store.state.course.listStatus.pageSize * (this.$store.state.course.listStatus.currentPage - 1) 
                                                            + 1 + ' - ' + 
                                                            (this.$store.state.course.listStatus.pageSize * (this.$store.state.course.listStatus.currentPage - 1) 
                                                            + response.result.length) + ' 筆，' + ' 共 ' + this.$store.state.course.listStatus.total + ' 筆結果';
                        }
        
                        for(let i = 0 ; i < response.result.length ; i++) {
                            let resourceObj = {};
                            resourceObj.id = response.result[i].id;
                            resourceObj.code = response.result[i].code;
                            resourceObj.title = response.result[i].title;
                            resourceObj.department = response.result[i].actual_dep ? 
                            response.result[i].actual_dep.name : "";
                            resourceObj.category = response.result[i].category.title;
                            resourceObj.level = response.result[i].level;
                            resourceObj.type = response.result[i].fileAttrs;
                            resourceObj.secret = response.result[i].secret;
                            resourceObj.mtime = response.result[i].mtime;
                            resourceObj.author = response.result[i].author;
                            if(response.result[i].rating) {
                                resourceObj.rating = Math.ceil(response.result[i].rating.average*10)/10;
                            } else {
                                resourceObj.rating = 0;	
                            }
                            resourceObj.fileAttrs = response.result[i].fileAttrs; 
                            this.courses.push(resourceObj);
                        }
                    }
                }
            });
        },
        showDialog() {
            this.form.resourceTitle = null;
            this.selectedItem = null;
            this.dialogFormVisible = true;
            if (this.$refs["form"] !== undefined) {
                this.$refs["form"].resetFields();
            }
        },
        querySearchAsync(queryString, cb) {
            API.getResources({
					categoryId: 0,
					keyword: queryString,
				}).then((response) => {
                if(response) {
                    let queryResult = [];
                    for(let i = 0 ; i < response.result.length ; i++) {
                        let obj = {};
                        obj.id = response.result[i].id;
                        obj.code = response.result[i].code;
                        obj.title = response.result[i].title;
                        obj.value = obj.title;
                        queryResult.push(obj);
                    }
                    cb(queryResult);
                }
            });    
        },
        handleSelect(item) {
            this.selectedItem = item;
        },
        addCourse() {
            if (this.form.resourceTitle && (this.form.resourceTitle === this.selectedItem.value)) {
                API.addCourses({
                        resource_id: this.selectedItem.id,
                        actual_depid: this.selectedDepId[1],
                        type: this.courseType,
                    }).then((response) => {
                    if(response.status) {
                        let code = JSON.parse(response.request.response).error_code;
                        if (code === "ERROR_SCIENCE_COURSE_COMPULSORY_EXIST") {
                            this.showHint('此主題已存在必修課程!');
                        } else if (code === "ERROR_SCIENCE_COURSE_ELECTIVE_EXIST") {
                            this.showHint('此主題已存在選修課程!');
                        } else {
                            this.showHint('新增課程發生錯誤!');
                        }
                    } else {
                        this.dialogFormVisible = false;
                        this.reloadCourse();
                    }
                });
            } else {
                this.$message.error('請重新選擇主題!');
            }
        },
        deleteCourses() {
            this.$confirm('確定刪除選中課程嗎 ?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            }).then(async () => {
                this.listLoading = true;
                for(let i = 0 ; i < this.sels.length ; i++) {
                    await API.deleteCourses(this.sels[i].id, this.selectedDepId[1]
                        ).then((response) => {
                    });
                }
                this.reloadCourse();
            }).catch(() => {

            });
        },
        course_current_change(val) {
            this.$store.state.course.listStatus.currentPage = val;
            let offset = this.$store.state.course.listStatus.pageSize * (this.$store.state.course.listStatus.currentPage - 1);
            this.$store.state.course.listStatus.offset = offset;
            this.getCourse();
        },
        formatType(row, column) { 
            return util.resourceInfo.formatType(row.type);
        },
        formatLevel: function (row, column) {
            return 'L ' + row.level;
        },
        formatMtime: function (row, column) {	
            if(row.mtime === null || row.mtime === 0 || row.mtime === undefined) {
                return '-';
            }

            return util.formatDate.format(new Date(row.mtime), 'yyyy-MM-dd');
        },
        selsChange: function (sels) {
            this.sels = sels;
        },
        sortChange: function(column, prop, order) {	
            //update sort order
            if(column.order === 'descending') {
                this.$store.state.course.listStatus.order = 'desc';	
            } else if(column.order  === 'ascending') {
                this.$store.state.course.listStatus.order = 'asc';	
            } else {
                this.$store.state.course.listStatus.order = null;		
            }
            //update sort by
            this.$store.state.course.listStatus.by = column.prop;

            //取得資源列表
            this.reloadCourse();
        },
        rowClick: function(row, event) {
            if(event.target.nodeName === 'SPAN' || event.target.nodeName === 'INPUT') {
                return;
            }
            this.$store.state.barBreadcrumbs = [];
            this.$store.state.entrance = "course";
            this.$router.push({ path: '/info/' +  row.id});
        },
        closeHint: function() {
            this.hint.display = false;
            this.$store.state.hintStatus.table = false;
            clearTimeout(this.timer);
        },
        showHint: function(message) {
            if(this.timer) {
                clearTimeout(this.timer);	
            }
            this.hint.display = true;
            this.hint.message = message;	
            this.$store.state.showHint = true;
            this.$store.state.hintStatus.table = true;
            this.timer = setTimeout(()=>{
                if(this.$store.state.showHint) {
                    this.$store.state.showHint = false;
                    this.$store.state.hintStatus.table = false;
                }
            }, this.$store.state.fadeOutTime);
        },
    },
    created() {
        this.init();
    }
}
</script>

<style lang="scss">
.course-autocomplete {
    li {
        line-height: normal;
        padding: 7px;

        .title {
            color: #1D2327;
            font-size: 14px;
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .code {
            font-size: 12px;
            color:  #737373;
        }

        .highlighted .code {
            color: #ddd;
        }
    }
}
</style>


// WEBPACK FOOTER //
// CourseType.vue?3074680b